import isPropValid from '@emotion/is-prop-valid';
import { styled } from '@ori-ui/mui';

export const MobileOfficeRoot = styled('div', {
  shouldForwardProp: (propName: string) => isPropValid(propName),
})<{ isMobileOffice?: boolean | undefined; isMobileOfficeFull?: boolean | undefined }>(({
  isMobileOffice,
  isMobileOfficeFull,
  theme,
}) => {
  if (isMobileOfficeFull) {
    return {
      '@media (min-width: 1025px)': {
        // Since there is a left menu, we have to set this style to make footer elements centered within the right container area.
        borderLeft: '280px solid transparent',
      },
      '@media (min-width: 1604px)': {
        borderLeft: 'none',
      },
    };
  }

  if (isMobileOffice) {
    return {
      '@media (min-width: 1025px)': {
        borderLeft: '280px solid transparent',
      },
      '@media (min-width: 1604px)': {
        borderLeft: 'none',
      },
    };
  }

  return {};
});
